"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.parse-int.js");

var _vuePopper = _interopRequireDefault(require("element-ui/lib/utils/vue-popper"));

var _popup = require("element-ui/lib/utils/popup");

var _dom = require("element-ui/lib/utils/dom");

var _debounce = _interopRequireDefault(require("throttle-debounce/debounce"));

var _tooltip = _interopRequireDefault(require("element-ui/lib/tooltip"));

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    ref: "rightMenu",
    attrs: {}
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPopper,
      expression: "showPopper"
    }],
    staticClass: "el-table-menu",
    attrs: {}
  }, _vm._l(_vm.menus, function (menu) {
    return _c('li', {
      key: menu.command,
      staticClass: "el-table-menu__list",
      attrs: {
        "id": menu.command
      },
      on: {
        "mouseenter": function mouseenter($event) {
          $event.stopPropagation();

          _vm.handleItemMouseEnter($event, menu);
        },
        "mouseleave": function mouseleave($event) {
          $event.stopPropagation();
          return _vm.handleItemMouseLeave($event);
        }
      }
    }, [_c('a', {
      staticClass: "el-table-menu__list-item",
      "class": {
        'is-multilevel': menu.children,
        'is-disabled': menu.disabled
      },
      attrs: {},
      on: {
        "click": function click($event) {
          _vm.menuClick($event, menu.command, menu);
        }
      }
    }, [_c('i', {
      staticClass: "el-table-menu__icon-block",
      "class": menu.icon,
      attrs: {}
    }), _vm._v(" "), _c('span', {
      staticClass: "el-table-menu__list-text",
      attrs: {}
    }, [_vm._v(_vm._s(menu.label))])]), _vm._v(" "), menu.children ? _c('ul', {
      staticClass: "el-table-menu__list-children",
      attrs: {}
    }, _vm._l(menu.children, function (child, index) {
      return _c('li', {
        key: index,
        staticClass: "el-table-menu__list",
        attrs: {}
      }, [_c('a', {
        staticClass: "el-table-menu__list-item",
        attrs: {},
        on: {
          "click": function click($event) {
            _vm.menuClick($event, child.command, menu);
          }
        }
      }, [_c('i', {
        "class": child.icon,
        attrs: {}
      }), _vm._v(" "), _c('span', {
        staticClass: "el-table-menu__list-text",
        attrs: {}
      }, [_vm._v(_vm._s(child.label))])])]);
    })) : _vm._e()]);
  })), _vm._v(" "), _c('el-tooltip', {
    ref: "tooltip",
    attrs: {
      "effect": "dark",
      "placement": "left"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.tooltipContent)
    },
    slot: "content"
  })])], 1);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElTableMenuPanel',
  mixins: [_vuePopper["default"]],
  components: {
    ElTooltip: _tooltip["default"]
  },
  props: {
    placement: {
      type: String,
      "default": 'bottom-start'
    },
    offset: {
      "default": 0
    }
  },
  created: function created() {
    this.activateTooltip = (0, _debounce["default"])(50, function (tooltip) {
      return tooltip.handleShowPopper();
    });
  },
  methods: {
    handleOutsideClick: function handleOutsideClick(e) {
      var el = this.$el;

      if (el.contains(e.target) || el === e.target) {
        return;
      }

      this.showPopper = false;
    },
    menuClick: function menuClick(event, eventType, menu) {
      var target = event.target;

      if (target.tagName === 'SPAN' || target.tagName === 'I') {
        target = target.parentNode;
      }

      if (target.tagName !== 'A') {
        return;
      }

      if (target.className.indexOf('is-disabled') !== -1) {
        return;
      }

      this.table.$emit('contextmenu-command', eventType, menu, this.row);
      this.showPopper = false;
    },
    handleItemMouseEnter: function handleItemMouseEnter(event, row) {
      var cellChild = event.currentTarget;

      if (!row.tip) {
        return;
      }

      if (this.$refs.tooltip) {
        var tooltip = this.$refs.tooltip;
        this.tooltipContent = row.tip;
        tooltip.referenceElm = cellChild;
        tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none');
        tooltip.doDestroy();
        tooltip.setExpectedState(true);
        this.activateTooltip(tooltip);
      }
    },
    handleItemMouseLeave: function handleItemMouseLeave(event) {
      var tooltip = this.$refs.tooltip;

      if (tooltip) {
        tooltip.setExpectedState(false);
        tooltip.handleClosePopper();
      }
    },
    handleRightClick: function handleRightClick(event) {
      event.preventDefault();
    }
  },
  data: function data() {
    return {
      referenceElm: null,
      table: null,
      row: null,
      menus: [],
      tooltipContent: ''
    };
  },
  mounted: function mounted() {
    this.popperElm = this.$el;
    (0, _dom.on)(document, 'mousedown', this.handleOutsideClick);
    (0, _dom.on)(this.table.$el, 'contextmenu', this.handleRightClick);
    (0, _dom.on)(this.$refs.rightMenu, 'contextmenu', this.handleRightClick);
  },
  watch: {
    showPopper: function showPopper(val) {
      if (val === true && parseInt(this.popperJS._popper.style.zIndex, 10) < _popup.PopupManager.zIndex) {
        this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      }

      if (val === true) {
        (0, _dom.addClass)(this.currentTr, 'current-row');
      } else {
        (0, _dom.removeClass)(this.currentTr, 'current-row');
      }
    }
  },
  destroyed: function destroyed() {
    (0, _dom.off)(document, 'mousedown', this.handleOutsideClick);
    (0, _dom.off)(this.$refs.rightMenu, 'contextmenu', this.handleRightClick);
    (0, _dom.off)(this.table.$el, 'contextmenu', this.handleRightClick);
  }
};
exports["default"] = _default;